const PayrollRoutes = [
    {
        path: '/payroll/salary-bonus',
        component: () => import('@/views/Payroll/Bonus/PayrollBonusView.vue'),
    },
    {
        path: '/payroll/salary-deduction',
        component: () => import('@/views/Payroll/Deduction/PayrollDeductionView.vue'),
    },
    {
        path: '/payroll/deduction-type',
        component: () => import('@/views/Payroll/Deduction/PAY_DeductionTypeView.vue'),
    },
    {
        path: '/payroll/salary-calculator',
        component: () => import('@/views/Payroll/SalaryCalculatorView.vue'),
    },
    {
        path: '/payroll/master-payroll',
        component: () => import('@/views/Payroll/MasterPayrollView.vue'),
    },
    {
        path: '/payroll/advance-salary',
        component: () => import('@/views/Payroll/SalaryAdvance/StaffAdvanceSalaryView.vue'),
    },
    {
        path: '/payroll/data-setup',
        component: () => import('@/views/Payroll/DataSetup/DataSetupView.vue'),
    },
    {
        path: '/payroll/tax-rate',
        component: () => import('@/views/Payroll/TaxRate/TaxRateView.vue'),
    },
]

export default PayrollRoutes
